












import Vue from 'vue'
import OptOutSaleDialog from '@/components/dialogs/privacy/OptOutSaleDialog.vue'
import ActionDialog from '@/components/atoms/ActionDialog.vue'

export default Vue.extend({
  components: {
    OptOutSaleDialog,
    ActionDialog
  },
  data: () => ({
    dialogVisible: false as boolean
  }),
  methods: {
    showDialog (): void {
      this.dialogVisible = true
    },
    hideDialog (): void {
      this.dialogVisible = false
    }
  }
})
